// 강제 로그아웃 등에서 기능 팝업(설정/이동/조직도/일정발송 등 confirmBase 계열)만 일괄로 닫기 위한 진입점. (OMD-27)
//
// 실제 닫기 로직(앱 `utils/ui` 의 confirmBase 레지스트리)은 앱 계층이 `setFunctionPopupCloser` 로 등록한다.
// packages(store saga) 는 앱 UI 를 직접 import 하면 안 되므로 주입(injection) 패턴을 쓴다.
// error/warning 모달(errorBase/warningBase)은 confirmBase 를 거치지 않으므로 이 대상에서 제외된다 → 로그아웃 후에도 유지.
export type FunctionPopupCloser = () => void

let closer: FunctionPopupCloser | null = null

export const setFunctionPopupCloser = (fn: FunctionPopupCloser): void => {
  closer = fn
}

export const closeFunctionPopups = (): void => {
  closer?.()
}
